.root {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.horizontalDivider {
  width: 100%;
  height: 2px;
  background-color: var(--border-soft);
}
